import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-success", "data-warning", "data-error", "data-neutral", "data-transparent", "data-borderless", "data-action"]

interface Props {
	type?: 'default' | 'success' | 'warning' | 'error' | 'neutral' | 'transparent';
	isBorderless?: boolean;
	hasAction?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Callout',
  props: {
    type: { default: 'default' },
    isBorderless: { type: Boolean, default: false },
    hasAction: { type: Boolean, default: false }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "callout",
    "data-success": __props.type === 'success' ? true : null,
    "data-warning": __props.type === 'warning' ? true : null,
    "data-error": __props.type === 'error' ? true : null,
    "data-neutral": __props.type === 'neutral' ? true : null,
    "data-transparent": __props.type === 'transparent' ? true : null,
    "data-borderless": __props.isBorderless ? true : null,
    "data-action": __props.hasAction ? true : null
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})